function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import AssetComponent from "components/core/asset/asset-component";
import { StyledFadeInAssetComponent } from "./fade-in-asset-component.scss";
const FadeInAssetComponent = ({ backgroundAsset, fadeInAsset, isInView, startingPosition, animationDuration, advancedAssetConfig })=>/*#__PURE__*/ _jsxs(StyledFadeInAssetComponent, {
        className: "fade-in-asset-component",
        startingPosition: startingPosition,
        animationDuration: animationDuration,
        fadeInAssetHeight: fadeInAsset === null || fadeInAsset === void 0 ? void 0 : fadeInAsset.height,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "background-asset-container",
                children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, backgroundAsset, advancedAssetConfig))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("fade-in-asset-container", {
                    visible: isInView
                }),
                children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, fadeInAsset, advancedAssetConfig))
            })
        ]
    });
export default FadeInAssetComponent;
